import React from "react";
import { Input } from "antd";

const ProductNameSearch = ({
  searchParams,
  setSearchParams,
  setCurrentPage,
}) => {
  const handleInputChange = (e) => {
    setCurrentPage(1);
    setSearchParams((prevParams) => ({
      ...prevParams,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
      <label style={{ fontWeight: 500 }}>Search Product:</label>
      <Input
        placeholder="Search product..."
        name="name"
        value={searchParams.name}
        onChange={handleInputChange}
      />
    </div>
  );
};

export default ProductNameSearch;
